
import Vue from "vue";
import { ITagOption, ISelectedFilter } from "../store/state";
import { search } from "../store/actions";

interface SearchFilterRemoverComputed {
  selectedFilters: ISelectedFilter[];
}

interface SearchFilterRemoverMethods {
  clearFilters(): void;
  deselectFilter(option: ISelectedFilter): void;
}

export default Vue.extend<{}, SearchFilterRemoverMethods, SearchFilterRemoverComputed, {}>({
  name: "SearchFilterRemover",
  computed: {
    selectedFilters() {
      return this.$store.getters.selectedFilters;
    },
  },

  methods: {
    clearFilters() {
      this.selectedFilters.forEach((f:ISelectedFilter) => {
        this.$store.commit({
          type: "setFilters",
          payload: f,
        });
        this.$store.commit({
          type: "setSelectedFilters",
          payload: f,
        });

      })
      this.$store.dispatch(search(""));
    },

    deselectFilter(option: ISelectedFilter) {
      this.$store.commit({
        type: "setFilters",
        payload: option,
      });

      this.$store.commit({
        type: "setSelectedFilters",
        payload: option,
      });

      this.$store.dispatch(search(""));
    },
  },
});
